import React from "react";
import {Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import axios from "axios";
import {toast} from 'react-toastify';
import ContactUs from "./components/ContactUs";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundCancellationPolicy from "./components/RefundCancellationPolicy";
import ShippingDeliveryPolicy from "./components/ShippingDeliveryPolicy";
import OrderSummaryCheckout from "./components/OrderSummaryCheckout ";

import {WifiIcon} from "@heroicons/react/solid";     
import AdminDashboard from "./components/AdminDashBoard/AdminDashboard";
import AdminMember from "./components/AdminMember/AdminMember";
import AdminFees from "./components/AdminFees/AdminFees";
import AdminDues from "./components/AdminDues/AdminDues";
import AdminExpense from "./components/AdminExpense/AdminExpense";
import AdminReport from "./components/AdminReport/AdminReport";
import AdminInvoiceCreateAll from "./components/AdminInvoiceCreateAll/AdminInvoiceCreateAll";
import AdminModeOfPayment from "./components/AdminModeOfPayment/AdminModeOfPayment";
import AdminInvoiceView from "./components/AdminInvoiceView/AdminInvoiceView";
import AdminInvoicePaymentEdit from "./components/AdminInvoicePaymentEdit/AdminInvoicePaymentEdit";
import AdminInvoiceEdit from "./components/AdminInvoiceEdit/AdminInvoiceEdit";      
import AdminExpenseList from "./components/AdminExpenseList/AdminExpenseList";
import AdminOrganizationProfile from "./components/AdminOrganizationProfile/AdminOrganizationProfile";
import AdminRelationship from "./components/AdminRelationship/AdminRelationship";
import AdminHouseNumber from "./components/AdminHouseNumber/AdminHouseNumber";
import AdminInvoice from "./components/AdminInvoice/AdminInvoice";
import CustomerMemberPaylist from "./components/CustomerMemberPaylist/CustomerMemberPaylist";
import CustomerProfile from "./components/CustomerProfile/CustomerProfile";
import AdminInvoiceRecordPayment from "./components/AdminRecordPayment/AdminRecordPayment";

{


    // axios.defaults.baseURL = 'https://arwa.dreamstech.biz/api/4/larwa/public';
    // axios.defaults.baseURL = 'http://localhost/parthi/laravel/larwa/public';
    // axios.defaults.baseURL = 'http://localhost/arun/arwa/larwa/public';
    axios.defaults.baseURL = '  https://apartment.axninfotech.in/api/1/public';

    //axios.defaults.baseURL = 'http://192.168.1.2/karthikg/laravel/larwa/public';


    axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });


    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data

        return response;
    }, function (error) {

        const customId = "custom-id-yes";
        if (error.response.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            window.location.href = '/crm';
        }
        if (error.response.status == 0) {
            //alert("Check  your network connection");
            //window.confirm("Check  your network connection")
            toast.warn("Check  your network connection !", {
                position: toast.POSITION.TOP_RIGHT,
                icon: WifiIcon,
                toastId: customId
            });
        }

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
    /*  axios.defaults.withCredentials=true;
    axios.interceptors.request.use( function (config){
    const token=localStorage.getItem('token');
    config.headers.Accept='application/json';
    config.headers.Authorization =token ? `Bearer ${token}`  : '';
    });
    */
}


function App() {
    return (

        <Routes>
            <Route path="/" element={<Login/>}/>
            <Route path="/Login" element={<Login/>}/>
         
            <Route path="/contact/us" element={<ContactUs/>}/>
            <Route path="/terms/conditions" element={<TermsConditions/>}/>
            <Route path="/privacy/policy" element={<PrivacyPolicy/>}/>
            <Route path="/refund/cancellation/policy" element={<RefundCancellationPolicy/>}/>
            <Route path="/shipping/delivery/policy" element={<ShippingDeliveryPolicy/>}/>
            <Route path="/order/summary/checkout" element={<OrderSummaryCheckout/>}/>

            <Route path="/admin/dashboard" element={<AdminDashboard/>}/>
            <Route path="/admin/member" element={<AdminMember/>}/>
            <Route path="/admin/fees" element={<AdminFees/>}/>
            <Route path="/admin/dues" element={<AdminDues/>}/>
            <Route path="/admin/expense" element={<AdminExpense/>}/>
            <Route path="/admin/report" element={<AdminReport/>}/>
            <Route path="/admin/Invoiceforallmembers" element={<AdminInvoiceCreateAll/>}/>
            <Route path="/admin/modeofepayment" element={<AdminModeOfPayment/>}/>
            <Route path="/admin/invoice" element={<AdminInvoice/>}/>
            <Route path="/admin/invoiceview/:id" element={<AdminInvoiceView/>}/>
            <Route path="/admin/invoicerecordpaymentedit/:id" element={<AdminInvoicePaymentEdit/>}/>
            <Route path="/admin/invoiceedit/:id" element={<AdminInvoiceEdit/>}/>
            <Route path="/admin/expense/categorylist" element={<AdminExpenseList/>}/>
            <Route path="/admin/organization/profile" element={<AdminOrganizationProfile/>}/>
            <Route path="/admin/relationship/list" element={<AdminRelationship/>}/>
            <Route path="/admin/housenumber/list" element={<AdminHouseNumber/>}/>
            <Route path="/admin/invoice/record/payment/:id" element={<AdminInvoiceRecordPayment/>}/>

            <Route path="/member/pay/list" element={<CustomerMemberPaylist/>}/>
            <Route path="/member/profile" element={<CustomerProfile/>}/>
        </Routes>
    );
}

export default App;
